import facebookMessenger from './facebookMessengerIcon.svg?raw'
import scheduledVideo from './scheduledVideoIcon.svg?raw'
import knowledgeBase from './knowledgeBase.svg?raw'
import whatsApp from './whatsAppIcon.svg?raw'
import callback from './callbackIcon.svg?raw'
import search from './searchIcon.svg?raw'
import audio from './audioIcon.svg?raw'
import video from './videoIcon.svg?raw'
import chat from './chatIcon.svg?raw'

export const channelPickerIcons = {
  facebook: facebookMessenger,
  scheduledVideo: scheduledVideo,
  knowledgeBase: knowledgeBase,
  genesysWhatsapp: whatsApp,
  callMeNow: callback,
  search: search,
  audio: audio,
  video: video,
  chat: chat,
}
